export const Config = {
    GRAPHQL_API: window._env_.GRAPHQL_API,
    MEDIA_URL: window._env_ ? window._env_.MEDIA_URL : '',
    JWT_AUTH_HEADER_PREFIX: "Bearer",
    AUTH_TOKEN_KEY: "auth.token"
};
